import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Header from "../Header";
import Footer from "../Footer";
import config from '../../config';
import SearchComponent from '../matching/SearchComponent';
import PopupService from '../PopupService';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../ApiContext';
import { lightFormat } from 'date-fns';
import { apiFetch } from '../utils/ApiFetch';


function DraftReview() {
	const navigate = useNavigate(); //
	const [levelUrl, setLevelUrl] = useState('/levelmatching');
	const { callApi, setIsApiLoading } = useApi();
	const [showAlertDetailTab, setShowAlertDetailTab] = useState(false);
	const [batchMatchCriteria, setBatchMatchCriteria] = useState(false);
	const [isKeywordSearchVisible, setIsKeywordSearchVisible] = useState(false);
	const [keywordOptions, setKeywordOptions] = useState({ showSaveOptions: false, showDeleteOptions: false });
	const [totalRecords, setTotalRecords] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const [viewMode, setViewMode] = useState('table');
	const sessionuser = sessionStorage.getItem('username');
	const username = sessionStorage.getItem("username");
	const mrToken = localStorage.getItem("mr_token");
	const location = useLocation();
	const { batchMatchId, clientId, matchResultId, matchResultType } = location.state || {};
	const batchMatchIdRef = useRef(batchMatchId);
	const matchResultIdRef = useRef(matchResultId);
	const [data, setData] = useState(null);
	const [rowdata, setRowData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedClient, setSelectedClient] = useState(clientId || '');
	const [searchQuery, setSearchQuery] = useState('');
	const [bigMatchResult, setBigMatchResult] = useState('OFF');
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const matchresultId = useRef(null);
	const lvl1aCount = useRef(null);
	const lvl2aCount = useRef(null);
	const lvl2bCount = useRef(null);
	const lvl2cCount = useRef(null);
	const lvl3aCount = useRef(null);
	const kwCount = useRef(null);
	const [dateFilter, setDateFilter] = useState("NOT_CONFIGURED");
	const [level, setLevel] = useState('1a');
	const [activeTab, setActiveTab] = useState('Prd Mnfr Ctg (' + (lvl1aCount.current || 0) + ')');
	const columns = data?.UNIQUE_COL_NAMES_NO_ID || [];
	const paginatedRows = rowdata; // Just use the data returned from API directly
	const [checkedItems, setCheckedItems] = React.useState([]);
	const pageGroupSize = 10;
	const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
	const startPage = currentGroup * pageGroupSize + 1;
	const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);
	const pageNumbers = [];
	const isRequestSent = useRef(false);
	for (let i = startPage; i <= endPage; i++) {
		pageNumbers.push(i);
	}
	const [excludeFieldDropdownVisible, setExcludeFieldDropdownVisible] = useState(false);
	const [excludeFieldOptions, setExcludeFieldOptions] = useState([]);
	const excludeFieldDropdownRef = useRef(null);
	const isRequestInProgress = useRef(false);
	const [excludeField, setExcludeField] = useState(null);
	const [reviewStatus, setReviewStatus] = useState('');
	const [countMatched, setCountMatched] = useState(0);
	const [countUnmatched, setCountUnmatched] = useState(0);
	const [draftReviewBy, setDraftReviewBy] = useState('');
	const [draftReviewTimestamp, setDraftReviewTimestamp] = useState('');
	const [finalReviewBy, setFinalReviewBy] = useState('');
	const [finalReviewTimestamp, setFinalReviewTimestamp] = useState('');
	const [productCriteria, setProductCriteria] = useState('');
	const [mfrCriteria, setMfrCriteria] = useState('');
	const [ctlgCriteria, setCtlgCriteria] = useState('');
	const [alertDetail, setAlertDetail] = useState(null);
	const [mrNumber, setMrNumber] = useState('');
	const [alertTitle, setAlertTitle] = useState('');
	const [clientName, setClientName] = useState('');
	const searchComponentRef = useRef(null);
	const [isMinimized, setIsMinimized] = useState(true);
	const [attachments, setAttachments] = useState([]); // State to store attachments
	
	const toggleCard = () => {
		setIsMinimized((prev) => !prev);
	};
	// Handle CONFIGURED state for dateFilter
	useEffect(() => {
		if (dateFilter === 'CONFIGURED') {
			const newFilter = 'ON';
			setDateFilter(newFilter);
			if (matchresultId.current && level) {
				fetchRowData(level, newFilter);
			}
		}
	}, [dateFilter, level]);


	// Add this function to your component
	const handleAttachmentDownload = async (file) => {
		try {
			const response = await apiFetch(`${config.API_BASE_URL}/attachment_download/${file.mongoId}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Username': username,
					'Authorization': `Bearer ${mrToken}`
				}
			});
			if (!response.ok) throw new Error('Download failed');
			const blob = await response.blob();
			const disposition = response.headers.get('Content-Disposition');
			let fileName = file.fileName || 'attachment';
			if (disposition && disposition.includes('filename=')) {
				const match = disposition.match(/filename="?([^\";]+)"?/);
				if (match && match[1]) fileName = match[1];
			}
			const downloadUrl = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.download = fileName;
			a.href = downloadUrl;
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(downloadUrl);
		} catch (e) {
			PopupService.getInstance().showMessage('Failed to download attachment', false);
		}
	};


	const fetchDraftReview = async () => {
		setLoading(true);
		await callApi(async () => {
			setIsApiLoading(true);
			try {
				setCheckedItems([]);
				const response = await apiFetch(`${config.API_BASE_URL}/draftreview`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({ batchMatchId: batchMatchIdRef.current, clientId: selectedClient, 
						matchResultId:matchResultIdRef.current, bigMatchResult: bigMatchResult}),
				});
				if (response.ok) {
					const result = await response.json();
					matchresultId.current = result.data.BATCH_MATCH_RESULT.mongoId;
					setMrNumber(result.data.BATCH_MATCH_RESULT.mrNumber);
					setBigMatchResult(result.data.BATCH_MATCH_RESULT.matchResultType);
					setAlertTitle(result.data.ALERT_TITLE);

					if ((result.data.BATCH_MATCH_RESULT.matchResultType || '').toUpperCase() === 'BIG') {
					  setLevelUrl('/levelmatchingBig');
					  setBigMatchResult(result.data.BATCH_MATCH_RESULT.matchResultType)
					} else {
					  setLevelUrl('/levelmatching');
					}

					const initialDateFilter = result.data.DATE_FILTER_CONFIGURATION === 'CONFIGURED' ? 'ON' : result.data.DATE_FILTER;
					updateCounts(initialDateFilter, result.data.BATCH_MATCH_RESULT);
					setActiveTab('Prd Mnfr Ctg (' + (lvl1aCount.current || 0) + ')');
					setData(result.data);
					setDateFilter(initialDateFilter === 'CONFIGURED' ? 'CONFIGURED' : initialDateFilter);
					if (matchresultId.current) {

						await fetchRowData(
						  '1a',
						  initialDateFilter === 'CONFIGURED' ? 'ON' : initialDateFilter,
						  '',
						  (result.data.BATCH_MATCH_RESULT.matchResultType || '').toUpperCase() === 'BIG'
						    ? '/levelmatchingBig'
						    : '/levelmatching'
						);


						setExcludeFieldOptions(result.data.UNIQUE_COL_NAMES_NO_ID || []);
						const countKeyword = result.data.BATCH_MATCH_RESULT.countKeyword;
						setKeywordOptions({
							showSaveOptions: countKeyword === 0 || countKeyword === null,
							showDeleteOptions: countKeyword > 0,
						});
					}
					// Set the new state values
					setReviewStatus(result.data.BATCH_MATCH_RESULT.status);
					if (['FINAL_REVIEW_DONE', 'DRAFT_REVIEW_DONE'].includes(result.data.BATCH_MATCH_RESULT.status)) {
						
						setDraftReviewBy(result.data.BATCH_MATCH_RESULT.draftReviewBy || '');
						setDraftReviewTimestamp(result.data.BATCH_MATCH_RESULT.draftReviewTimestamp || '');
						setFinalReviewBy(result.data.BATCH_MATCH_RESULT.finalReviewBy || '');
						setFinalReviewTimestamp(result.data.BATCH_MATCH_RESULT.finalReviewTimestamp || '');
						if(result.data.MATCHING_TYPE === 'BIG'){
							setCountMatched (result.data.BIG_DRAFT_COUNT || 0);
							setCountUnmatched(result.data.BIG_UNMATCHED_COUNT || 0);
							
						}else{
							setCountMatched(result.data.DRAFT_BUCKET.matchedCount || 0);
							setCountUnmatched(result.data.DRAFT_BUCKET.unMatchedCount || 0);
						}
					}
					const criteria = result.data.BATCH_MATCH_CRITERIA || {};
					setProductCriteria(criteria.productCriteria || 'N/A');
					setMfrCriteria(criteria.mfrCriteria || 'N/A');
					setCtlgCriteria(criteria.ctlgCriteria || 'N/A');
				} else {
					setData(null);
				}
			} catch (error) {
				setData(null);
			} finally {
				setLoading(false);
				isRequestSent.current = false;
				setExcludeField(null);
				setIsApiLoading(false);
			}
		});
	};


	useEffect(() => {
		if (batchMatchIdRef.current && selectedClient && !isRequestSent.current) {
			isRequestSent.current = true;
			fetchDraftReview();
		}
	}, [selectedClient]);

	const fetchRowData = async (levelParam, dateFilterParam, searchText = '', urlOverride = null, pageNumber = null, excludeFieldParam = null, pageSizeParam = pageSize) => {
		// Use pageSizeParam instead of relying on the state
        setLoading(true);
		if (isRequestInProgress.current) return;
		isRequestInProgress.current = true;
		return await callApi(async () => {
			setIsApiLoading(true);
			try {

				const filterToSend = dateFilterParam === 'CONFIGURED' ? 'ON' : dateFilterParam;
				
				// Use urlOverride if provided, otherwise use the current levelUrl state
				const endpointUrl = urlOverride || levelUrl;

				// Use the provided pageNumber parameter, or fall back to current state
				const pageToSend = pageNumber || currentPage;

				// Update the current page state if a page number was provided
				if (pageNumber) {
					setCurrentPage(pageNumber);
				}

				const response = await apiFetch(`${config.API_BASE_URL}${endpointUrl}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({
						matchResultId: matchresultId.current,
						batchMatchId:batchMatchIdRef.current,
						clientId: selectedClient,
						level: levelParam,
						dateFilter: filterToSend,
						search: searchText,
						username: sessionuser,
						pageNo: pageToSend,
						limit: pageSizeParam,
						excludeField: excludeFieldParam
					}),
				});
				if (response.ok) {
					const result = await response.json();

					setRowData(result.data.SEARCH_LIST || []);
					setTotalPages(result.data.total || 0);
					setTotalRecords(result.data.records || 0);

					if (dateFilter === 'NOT_CONFIGURED') {
						const newFilter = result.data.DATE_FILTER === 'CONFIGURED' ? 'CONFIGURED' : result.data.DATE_FILTER;
						setDateFilter(newFilter);
					}

					await setLevel(result.data.LEVEL || levelParam);

					// Only attempt to update counts if BATCH_MATCH_RESULT exists
					if (result.data.BATCH_MATCH_RESULT) {
						updateCounts(filterToSend, result.data.BATCH_MATCH_RESULT);
					}

					if (result.data.LEVEL === '1a') {
						setActiveTab('Prd Mnfr Ctg (' + (lvl1aCount.current || 0) + ')');
					}
				} else {
					setRowData([]);
					setTotalRecords(0);
					if (dateFilter === 'NOT_CONFIGURED') {
						setDateFilter("NOT_CONFIGURED");
					}
				}

			} catch (error) {
				console.error("Error fetching row data:", error);
				setRowData([]);
				if (dateFilter === 'NOT_CONFIGURED') {
					setDateFilter("NOT_CONFIGURED");
				}
			} finally {
				setLoading(false);
				isRequestInProgress.current = false;
				setIsApiLoading(false);
			}
		});
	};


	const handleClientChange = async (e) => {
	  setIsMinimized(true);
	  setShowAlertDetailTab(false);
	  setBatchMatchCriteria(false);
	  const newClientId = e.target.value;
	  const selectedClientName = e.target.options[e.target.selectedIndex]?.text || '';
	  setSelectedClient(newClientId); // Fix: update to new client ID only
	  setClientName(selectedClientName);
	  setLevel('1a');
	  setCurrentPage(1);
	  setExcludeField(null);
	  handleViewAlertDetail(mrNumber, newClientId);
	};



	const handleDateFilterToggle = async () => {
		await callApi(async () => {
			setIsApiLoading(true);
			try {
				let newFilter;
				if (dateFilter === 'CONFIGURED' || dateFilter === 'OFF') {
					newFilter = 'ON';
				} else {
					newFilter = 'OFF';
				}
				setLoading(true);
				setDateFilter(newFilter);
				setCurrentPage(1);
				
				const response = await apiFetch(`${config.API_BASE_URL}/levelmatching`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({
						matchResultId: matchresultId.current,
						batchMatchId: batchMatchIdRef.current || batchMatchId,
						clientId: selectedClient,
						level: level,
						dateFilter: newFilter,
						username: sessionuser,
						pageNo: 1,
						limit: pageSize
					}),
				});
				if (response.ok) {
					const result = await response.json();
					setRowData(result.data.SEARCH_LIST || []);
					updateCounts(newFilter, result.data.BATCH_MATCH_RESULT);
					const tabName = getTabNameForLevel(level);
					setActiveTab(tabName);
					setTotalPages(result.data.total || 0);
					setTotalRecords(result.data.records || 0);
				} else {
					setDateFilter(dateFilter === 'ON' ? 'ON' : 'OFF');
					console.error("Error response from server");
				}
			} catch (error) {
				console.error("Error toggling date filter:", error);
				setDateFilter(dateFilter === 'ON' ? 'ON' : 'OFF');
			} finally {
				setLoading(false);
				setIsApiLoading(false);
			}
		});
	};

	const getTabNameForLevel = (lvl) => {
		switch (lvl) {
			case '1a': return `Prd Mnfr Ctg (${lvl1aCount.current || 0})`;
			case '2a': return `Mnfr Ctlg (${lvl2aCount.current || 0})`;
			case '2b': return `Prd Ctlg (${lvl2bCount.current || 0})`;
			case '2c': return `Mnfr Product (${lvl2cCount.current || 0})`;
			case '3a': return `Catalog (${lvl3aCount.current || 0})`;
			case 'keyword': return `Keyword (${kwCount.current || 0})`;
			default: return `Prd Mnfr Ctg (${lvl1aCount.current || 0})`;
		}
	};


	// Add this useEffect to set clientName when data is first loaded
	useEffect(() => {
		if (data?.ACTIVE_CLIENTS?.length > 0 && selectedClient) {
			// Find the selected client in the active clients list
			const clientObj = data.ACTIVE_CLIENTS.find(client => client.clientId === selectedClient);
			if (clientObj) {
				setClientName(clientObj.clientName);
			}
		}
	}, [data, selectedClient]);



	const updateCounts = (dateFilter, batchMatchResult) => {
		// Early return if batchMatchResult is undefined
		if (!batchMatchResult) {
			console.warn("Warning: batchMatchResult is undefined in updateCounts");
			return;
		}

		if (dateFilter === 'ON') {
			lvl1aCount.current = batchMatchResult.count1aDf;
			lvl2aCount.current = batchMatchResult.count2aDf;
			lvl2bCount.current = batchMatchResult.count2bDf;
			lvl2cCount.current = batchMatchResult.count2cDf;
			lvl3aCount.current = batchMatchResult.count3aDf;
			kwCount.current = batchMatchResult.countKeywordDf;
		} else {
			lvl1aCount.current = batchMatchResult.count1a;
			lvl2aCount.current = batchMatchResult.count2a;
			lvl2bCount.current = batchMatchResult.count2b;
			lvl2cCount.current = batchMatchResult.count2c;
			lvl3aCount.current = batchMatchResult.count3a;
			kwCount.current = batchMatchResult.countKeyword;
		}
	};


	const handleCheckboxChange = (id, isChecked) => {
		setCheckedItems((prev) =>
			isChecked ? [...prev, id] : prev.filter((item) => item !== id)
		);
	};

	const handleButtonClick = async (action) => {
		if (checkedItems.length === 0) {
			PopupService.getInstance().showMessage('No items selected, please select atleast one item to continue', false, 3000);
			return;
		}
		try {
			const response = await apiFetch(`/api/${action}`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
				body: JSON.stringify({ items: checkedItems }),
			});
			if (response.ok) {
				alert(`${action} action completed successfully`);
				setCheckedItems([]);
			} else {
				alert(`Failed to perform ${action} action`);
			}
		} catch (error) {
			console.error(`Error performing ${action} action:`, error);
		}
	};

	const selectAllCheckboxChange = (isChecked) => {
		if (isChecked) {
			const allItemIds = rowdata.map((row) => row.mongo_id);
			setCheckedItems(allItemIds);
		} else {
			setCheckedItems([]);
		}
	};


	const handleOptionSelect = async (option) => {		
		if(levelUrl === '/searchKeyword'){
			PopupService.getInstance().showMessage('Cannot apply exclude filter, first save the keyword search and then apply exclude field', false, 3000);
		    return;
		}
		try {
			if (option === null) {
				setExcludeField(null);
				
				fetchRowData(level, dateFilter, searchQuery, levelUrl, 1);
			} else {
				const newExcludeField = option.toLowerCase();
				setExcludeField(newExcludeField);
				//setCurrentPage(1);
				fetchRowData(level, dateFilter, searchQuery, levelUrl, 1, newExcludeField);
			}
		} catch (error) {
			console.error('Error sending selected option:', error);
		} finally {
			setExcludeFieldDropdownVisible(false);
		}
	};


	const handleExcludeFieldClick = () => {
		setExcludeFieldDropdownVisible((prev) => !prev);
	};

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				excludeFieldDropdownRef.current &&
				!excludeFieldDropdownRef.current.contains(event.target)
			) {
				setExcludeFieldDropdownVisible(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);


	const handleAddToBucket = async (action) => {
		let itemsToAdd = [];
		let addUrl = 'addToDraftBucket';
		if (action === 'selected') {
			if (checkedItems.length === 0) {
				PopupService.getInstance().showMessage('No items selected, please select at least one item to continue', false, 3000);
				return;
			}
			itemsToAdd = checkedItems;
		} else if (action === 'all') {
			addUrl = 'addAllToDraft';
			itemsToAdd = [];
		}
		await callApi(async () => {
			setIsApiLoading(true);
			try {

				const response = await apiFetch(`${config.API_BASE_URL}/${addUrl}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({
						matchIds: itemsToAdd,
						username: sessionuser,
						searchType: level,
						batchMatchId: batchMatchId,
						clientId: selectedClient,
						saveId: matchresultId.current,
						matchResultId: matchresultId.current,
						level: level,
						dateFilter: dateFilter,
						bigMatchResult:bigMatchResult,
						excludeField:excludeField,
						search:searchQuery
					}),
				});
				if (response.ok) {
					const result = await response.json();
					if(excludeField){
						await fetchRowData(level, dateFilter, searchQuery, levelUrl, 1, excludeField);
					}else{
						await fetchRowData(level, dateFilter, searchQuery, levelUrl)
					}
					setCheckedItems([]);
					PopupService.getInstance().showMessage(result.message, true, 3000);
				} else {
					const result = await response.json();
					PopupService.getInstance().showMessage(result.message, false, 3000);
					//alert(`Failed to add ${action === 'selected' ? 'selected items' : 'all items'} to bucket`);
				}

			} catch (error) {
				console.error(`Error adding ${action === 'selected' ? 'selected items' : 'all items'} to bucket:`, error);
			} finally {
				setIsApiLoading(false);
			}
		});
	};



	const handleDeleteFromBucket = async (action) => {
		let itemsToRemove = [];
		// Use let instead of const for delUrl since you need to reassign it
		let delUrl = 'deleteFromBucket';

		if (action === 'selected') {
			if (checkedItems.length === 0) {
				PopupService.getInstance().showMessage(`No items selected, please select at least one item to remove.`, false);
				return;
			}
			itemsToRemove = checkedItems;
		} else if (action === 'all') {
			delUrl = 'removeAllDraftFromBucket';
			itemsToRemove = [];
		}
		await callApi(async () => {
			setIsApiLoading(true);
			try {
				const response = await apiFetch(`${config.API_BASE_URL}/${delUrl}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({
						matchIds: itemsToRemove,
						username: sessionuser,
						searchType: level,
						batchMatchId: batchMatchId,
						clientId: selectedClient,
						saveId: matchresultId.current,
						matchResultId: matchresultId.current,
						level: level,
						dateFilter: dateFilter,
						bigMatchResult:bigMatchResult
					}),
				});
				if (response.ok) {
					const result = await response.json();
					if(excludeField){
						await fetchRowData(level, dateFilter, searchQuery, levelUrl, 1, excludeField);
					}else{
						await fetchRowData(level, dateFilter, searchQuery, levelUrl)
					}
					
					setCheckedItems([]);
					PopupService.getInstance().showMessage(result.message, true, 3000);
				} else {
					PopupService.getInstance().showMessage(`Failed to remove ${action === 'selected' ? 'selected items' : 'all items'} from bucket`, false, 3000);
				}
			} catch (error) {
				PopupService.getInstance().showMessage(`Error removing ${action === 'selected' ? 'selected items' : 'all items'} from bucket:`, false, 3000);
			} finally {
				setIsApiLoading(false);
			}
		});
	};


	const handleMakeDraftReviewComplete = async () => {
		await callApi(async () => {
			setIsApiLoading(true);
			try {
				const response = await apiFetch(`${config.API_BASE_URL}/savedraft`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({
						batchMatchId: batchMatchIdRef.current,
						clientId: selectedClient,
						username: sessionuser,
						bigMatchResult:bigMatchResult,
						matchResultId: matchresultId.current,
						mrNumber: mrNumber
					}),
				});

				if (response.ok) {
					const result = await response.json();
					PopupService.getInstance().showMessage(result.message, true, 3000);

					// Reload the page data with the current client
					isRequestSent.current = false; // Reset the flag to allow a new request
					await fetchDraftReview(); // This will reload all the data for the current client
				} else {
					PopupService.getInstance().showMessage('Failed to mark draft review as complete', false, 3000);
				}
			} catch (error) {
				console.error('Error marking draft review as complete:', error);
				PopupService.getInstance().showMessage('An error occurred while marking draft review as complete', false, 3000);
			} finally {
				setIsApiLoading(false);
			}
		});
	};


	const handleRowClick = (mongo_id, event) => {
		// Prevent toggling if the click is on the checkbox itself or if text is selected
		if (event.target.type === 'checkbox' || window.getSelection().toString()) return;
		setCheckedItems(prev =>
			prev.includes(mongo_id)
				? prev.filter(id => id !== mongo_id)
				: [...prev, mongo_id]
		);
	};




	const handleTabClick = async (tabLevel) => {
	  const newExcludeField = null;
	  const newPage = 1;
	  if (bigMatchResult && bigMatchResult.toUpperCase() === 'BIG') {
	    setLevelUrl('/levelmatchingBig');
	  } else {
	    setLevelUrl('/levelmatching');
	  }
	  setExcludeField(newExcludeField);
	  setLevel(tabLevel);
	  setCurrentPage(newPage);
	  setSearchQuery('');
	  if (searchComponentRef.current) {
	    searchComponentRef.current.clearSearch();
	  }
	  setIsKeywordSearchVisible(tabLevel === 'keyword');
	  if (tabLevel === 'keyword') {
	    setKeywordOptions({
	      showSaveOptions: false,
	      showDeleteOptions: true
	    });
	  }
	  setActiveTab(getTabNameForLevel(tabLevel));
	  // Send request for all tabs except keyword
	 
	    await fetchRowData(
	      tabLevel,
	      dateFilter,
	      '',
	      bigMatchResult && bigMatchResult.toUpperCase() === 'BIG' ? '/levelmatchingBig' : '/levelmatching',
	      newPage,
	      newExcludeField
	    );
	};

	const handleKeywordAction = async (action) => {
		if (action === 'startNewKeywordSearch') {
			// Set the level URL first
			setLevelUrl('/searchKeyword');
			setRowData([]);
			setKeywordOptions({
				showSaveOptions: true,
				showDeleteOptions: false
			})
			PopupService.getInstance().showMessage('The search mode is set to start a new Keyword Search!. '
				+ 'If you need to go back to search within available matches, click on the tabs', true, 6000);

		} else if (action === 'saveSelectedKeywordSearch') {

			saveKeywordSearch('selected');
			//if(bigMatchResult){
				//setLevelUrl('/levelmatchingBig');				
			//}else{
				//setLevelUrl('/levelmatching');				
			//}
			//fetchRowData(level, dateFilter, searchQuery, levelUrl, currentPage);
			
			//saveSelectedKWSearch
			//alert('saveSelectedKeywordSearch')					
		} else if (action === 'saveAllKeywordSearch') {
			saveKeywordSearch('all');
			fetchRowData(level, dateFilter, searchQuery, levelUrl, currentPage);
			setLevelUrl('/levelmatching');
		} else if (action === 'deleteSelectedKeywordSearch') {
			deleteKeywordSearch('selected');
		} else if (action === 'deleteAllKeywordSearch') {
			deleteKeywordSearch('all');
			//fetchRowData(level, dateFilter, searchQuery, levelUrl, 1);		
		} else {
			setLevelUrl('/levelmatching');
		}
	};

	const saveKeywordSearch = async (action) => {
		let itemsToAdd = [];
		let saveKWUrl = 'saveSelectedKWSearch';
		if (action === 'selected') {
			if (checkedItems.length === 0) {
				PopupService.getInstance().showMessage('No items selected, please select at least one item to continue', false, 3000);
				return;
			}
			itemsToAdd = checkedItems;
		} else if (action === 'all') {
			saveKWUrl = 'saveAllKWSearch';
			itemsToAdd = [];
		}
		await callApi(async () => {
			setIsApiLoading(true);
			try {
				
				const response = await apiFetch(`${config.API_BASE_URL}/${saveKWUrl}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({
						batchMatchId: batchMatchIdRef.current,
						clientId: selectedClient,
						matchIds: itemsToAdd,
						username: sessionuser,
						searchType: level,
						saveId: matchresultId.current,
						matchResultId: matchresultId.current,
						level: level,
						dateFilter: dateFilter,
						searchField: searchQuery,
						search: searchQuery,
						bigMatchResult:bigMatchResult
					}),
				});
				
				if (response.ok) {
					const result = await response.json();
					PopupService.getInstance().showMessage(result.message, true, 3000);
					updateCounts(dateFilter, result.data.BATCH_MATCH_RESULT);
					PopupService.getInstance().showMessage(result.message, true, 3000);
					setCheckedItems([]);
					setBigMatchResult(result.data.BATCH_MATCH_RESULT.matchResultType)
					if ((result.data.BATCH_MATCH_RESULT.matchResultType || '').toUpperCase() === 'BIG') {					  
					  setBigMatchResult(result.data.BATCH_MATCH_RESULT.matchResultType)
					  setLevel("keyword");
					} 

					setLevelUrl('/searchKeyword');
					await fetchRowData(level, dateFilter, searchQuery, levelUrl)
				}
			} catch (error) {
				console.error('Error saving selected keyword search:', error);
				PopupService.getInstance().showMessage('An error occurred while saving keyword search', false, 6000);
			} finally {
				setIsApiLoading(false);
			}
		});
	};


	const deleteKeywordSearch = async (action) => {
		let itemsToDelete = [];
		let delKWUrl = 'deleteSelectedKWSearch';
		if (action === 'selected') {
			if (checkedItems.length === 0) {
				PopupService.getInstance().showMessage('No items selected, please select at least one item to continue', false, 3000);
				return;
			}
			itemsToDelete = checkedItems;
		} else if (action === 'all') {
			delKWUrl = 'deleteAllKWSearch';
			itemsToDelete = [];
		}
		await callApi(async () => {
			setIsApiLoading(true);
			try {
				const response = await apiFetch(`${config.API_BASE_URL}/${delKWUrl}`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify({
						batchMatchId: batchMatchIdRef.current,
						clientId: selectedClient,
						matchIds: itemsToDelete,
						username: sessionuser,
						searchType: level,
						saveId: matchresultId.current,
						matchResultId: matchresultId.current,
						level: level,
						dateFilter: dateFilter,
						search: searchQuery,
						bigMatchResult:bigMatchResult
					}),
				});

				if (response.ok) {
					const result = await response.json();
					updateCounts(dateFilter, result.data.BATCH_MATCH_RESULT);
					PopupService.getInstance().showMessage(result.message, true, 3000);
					setCheckedItems([]);
					const countKeyword = result.data.BATCH_MATCH_RESULT.countKeyword;
					setKeywordOptions({
						showSaveOptions: countKeyword === 0 || countKeyword === null,
						showDeleteOptions: countKeyword > 0,
					});
					await fetchRowData(level, dateFilter, searchQuery, levelUrl)

					// Make sure the keyword tab is active after operation completes
					setActiveTab(`Keyword (${countKeyword || 0})`);
					setLevel('keyword');
				} else {
					PopupService.getInstance().showMessage('Failed to delete keyword search', false, 3000);
				}
			} catch (error) {
				console.error('Error deleting keyword search:', error);
				PopupService.getInstance().showMessage('An error occurred while deleting keyword search', false, 3000);
			} finally {
				setIsApiLoading(false);
			}
		});
	};

	// Add this function to handle direct page navigation via input field
	const handlePageInputChange = (e) => {
		const value = e.target.value.trim();
		if (value === '') return;

		const pageNumber = parseInt(value, 10);
		if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber <= totalPages) {
			fetchRowData(level, dateFilter, searchQuery, levelUrl, pageNumber);
		}
	};

	// Add this function to validate input and handle Enter key
	const handlePageInputKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			const value = e.target.value.trim();
			if (value === '') return;

			const pageNumber = parseInt(value, 10);
			if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber <= totalPages) {
				fetchRowData(level, dateFilter, searchQuery, levelUrl, pageNumber);
			} else {
				// Reset invalid input
				e.target.value = currentPage;
				PopupService.getInstance().showMessage(`Please enter a valid page number between 1 and ${totalPages}`, false, 3000);
			}
		}
	};

	const [cardContent, setCardContent] = useState(null); // State to track card content



	const handleViewAlertDetail = (mrNumber, selectedClient) => {
		setCardContent('alertDetail'); // Set content to "Alert Detail"
		//setIsMinimized(false); // Ensure the card is maximized
		fetchAlertDetail(mrNumber, selectedClient); // Fetch alert detail data
	};

	const handleViewMatchCriteria = () => {
		setCardContent('matchCriteria'); // Set content to "Match Criteria"
		setIsMinimized(false); // Ensure the card is maximized
	};

	const handleBackToMatchingSummary = () => {
        if (batchMatchId) {
			navigate('/matching/matchingsummary', {
				state: {
					mongoId: batchMatchId,
					...(mrNumber && { mrNumber }),
					...(alertTitle && { alertTitle })
				}
			});
		} else {
			console.error("batchMatchId is missing");
		}
	};

	const handleGoToFinalReview = () => {
        navigate('/matching/finalreview', { state: { batchMatchId, clientId, matchResultId, bigMatchResult } });
	};

	const fetchAlertDetail = async (mrNumber, clientId) => {
		await callApi(async () => {
			setIsApiLoading(true);
			try {
				if (typeof mrNumber !== 'string' || !mrNumber.trim()) {
					console.error('Invalid MR Number:', mrNumber);
					return;
				}

				const requestBody = { mrNumber, clientId };


				const response = await apiFetch(`${config.API_BASE_URL}/alertDetailForClient`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'X-Username': username, 'Authorization': `Bearer ${mrToken}` },
					body: JSON.stringify(requestBody),
				});

				if (response.ok) {
					const data = await response.json();
					setAlertDetail(data?.data?.SUPPORT_ALERT || null); // Populate alertDetail state
					setAlertTitle(data?.data?.SUPPORT_ALERT.alertTitle);
					setAttachments(data?.data?.ATTACHMENT_LIST || []); // Populate attachments state
				} else {
					console.error('Failed to fetch alert detail:', response.statusText);
					setAlertDetail(null);
					setAttachments([]);
				}

			} catch (error) {
				console.error('Error fetching alert detail:', error);
				setAlertDetail(null);
				setAttachments([]);
				setIsApiLoading(false);
			}
		});
	};




	return (
		<>
			<Header />
			<div className="container-fluid text-secondary">
				<br /><br /><br /><br />
				<div className="container-fluid no-margin no-padding text-secondary">
					<div className="card text-secondary">
						<div className="card-header">Draft Review - {clientName} ({selectedClient}) - {mrNumber} </div>
						<div className='card-body custom-card-bg'>
							<div className="card">
								<div className="card-header"><strong>Matching Details</strong></div>
								<div className="card-body">
									{loading ? (
										<div>Loading...</div>
									) : (
										<>
											<div className="row">
												<div className="col-md-3">
													<label htmlFor="clientDropdown" className="form-label me-3">Select Client:</label>
													<div className="col-md-11 me-3">
														<select
															id="clientDropdown"
															className="form-select"
															value={selectedClient}
															onChange={handleClientChange}
														>
															<option value="">-- Select Client --</option>
															{data?.ACTIVE_CLIENTS?.map((client, idx) => (
																<option
																	key={client.mongoId || idx}
																	value={String(client.clientId)} 
																>
																	{client.clientId} - {client.clientName}
																</option>
															))}
														</select>
													</div>
													{(dateFilter === 'CONFIGURED' || dateFilter === 'ON' || dateFilter === 'OFF') && (
														<div className="form-check form-switch">
															<input
																className={`form-check-input ${dateFilter === 'ON' ? 'text-danger' : ''}`}
																type="checkbox"
																id="dateFilterToggle"
																checked={dateFilter === 'ON'}
																onChange={handleDateFilterToggle}
															/>

															<label
																className={`form-check-label ${dateFilter === 'ON' ? 'text-danger' : ''}`}
																htmlFor="dateFilterToggle"
															>
																Date Filter: {dateFilter === 'ON' ? 'ON' : 'OFF'}
															</label>

														</div>
													)}
												</div>
												<div className="col-md-3">
												 <label htmlFor="clientDropdown" className="form-label me-3">Match Status:</label>
												 <br/>
												 {reviewStatus === 'DRAFT_REVIEW_DONE' ? (
													<>
												   <span className="badge bg-success">
												   <i className='fa fa-check'></i>&nbsp;&nbsp;
												   {reviewStatus}</span>
												   <br/>
												   Matched Count: {countMatched} <br/>Unmatched Count: {countUnmatched}
												   </>
												   ) : (
													<>
													<span className="badge bg-danger">
												   
												   {reviewStatus}</span>
												   
												   </>
												 )}
												 </div>
												<div className="col-md-6">
												<label className="form-label me-3">Alert Title:</label>
												  <br/><span className='text-info'> {alertTitle}</span>
												</div>
											</div>
											<br />
											<div className="row">
												<div className="col-md-12 mb-3">
													<div className="d-flex justify-content-start">

														<button
															className="btn btn-info btn-sm text-light"
															onClick={() => handleViewAlertDetail(mrNumber, selectedClient)} // Pass mrNumber as a parameter
														>
															View Alert Detail
														</button>

														<button
															className="btn btn-info btn-sm text-light ms-2"
															onClick={handleViewMatchCriteria}
														>
															View Match Criteria
														</button>
														<button
															className="btn btn-secondary btn-sm text-light ms-2"
															onClick={handleBackToMatchingSummary}
														>
															Back To Matching Summary
														</button>
														<button
															className="btn btn-secondary btn-sm text-light ms-2"
															onClick={handleGoToFinalReview}
														>
															Go To Final Review
														</button>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">

													<div className="card text-secondary">
														<div className="card-header d-flex justify-content-between align-items-center">
															<span>Match Review Detail</span>
															<button
																className="btn btn-sm btn-link text-secondary"
																onClick={() => setIsMinimized((prev) => !prev)} // Toggle using existing setIsMinimized
																style={{ textDecoration: 'none' }}
															>
																<i className={isMinimized ? "fa fa-plus" : "fa fa-minus"}></i>
															</button>
														</div>
														{!isMinimized && ( // Conditionally render the card body
															<div className="card-body" id="helper_div">
																<div className="row">
																	<div className="col-md-6">
																		<ul className="list-group text-secondary">
																			<li className="list-group-item text-secondary">
																				<span className="text-primary">Review Status:</span> {reviewStatus}
																			</li>
																			{['FINAL_REVIEW_DONE', 'DRAFT_REVIEW_DONE'].includes(reviewStatus) && (
																				<>
																					<li className="list-group-item text-secondary">
																						<span className="text-primary">Count Matched:</span> {countMatched}
																					</li>
																					<li className="list-group-item text-secondary">
																						<span className="text-primary">Count Unmatched:</span> {countUnmatched}
																					</li>
																				</>
																			)}
																		</ul>
																	</div>
																	<div className="col-md-6">
																		<ul className="list-group">
																			<li className="list-group-item text-secondary">
																				<span className="text-primary">Draft Review Status:</span> {reviewStatus}
																			</li>
																			{['FINAL_REVIEW_DONE', 'DRAFT_REVIEW_DONE'].includes(reviewStatus) && (
																				<>
																					<li className="list-group-item text-secondary">
																						<span className="text-primary">Draft Review Timestamp:</span> {draftReviewTimestamp}
																					</li>
																					<li className="list-group-item text-secondary">
																						<span className="text-primary">Final Review By:</span> {finalReviewBy}
																					</li>
																					<li className="list-group-item text-secondary">
																						<span className="text-primary">Final Review Timestamp:</span> {finalReviewTimestamp}
																					</li>
																				</>
																			)}
																		</ul>
																	</div>
																</div>
															</div>
														)}
													</div>

												</div>
												<div className="col-md-6">

													{cardContent && (


														<div className="card text-secondary">
															<div className="card-header d-flex justify-content-between align-items-center">
																<span>
																	{cardContent === 'alertDetail' && `Alert Detail - ${alertDetail?.mrNumber || ''}`}
																	{cardContent === 'matchCriteria' && 'Match Criteria'}
																	{!cardContent && 'Card Title'}
																</span>
																<button
																	className="btn btn-sm btn-link text-secondary"
																	onClick={toggleCard}
																	style={{ textDecoration: 'none' }}
																>
																	<i className={isMinimized ? "fa fa-plus" : "fa fa-minus"}></i>
																</button>
															</div>
															{!isMinimized && (
																<div className="card-body">
																	<div className="row mt-3">
																		{cardContent === 'alertDetail' && (
																			alertDetail ? (

																				<div className="col-md-6">

																					<ul className="list-group">
																						<li className="list-group-item active">Alert Detail</li>
																						<li className="list-group-item text-secondary"><strong>Title:</strong> {alertDetail.alertTitle}</li>
																						<li className="list-group-item text-secondary"><strong>Class:</strong> {alertDetail.alertClass}</li>
																						<li className="list-group-item text-secondary"><strong>Source:</strong> {alertDetail.alertSource}</li>
																						<li className="list-group-item text-secondary"><strong>Type:</strong> {alertDetail.alertType}</li>
																						<li className="list-group-item text-secondary"><strong>Manufacturer:</strong> {alertDetail.manufacturer}</li>
																						<li className="list-group-item text-secondary"><strong>Product Desc:</strong> <span dangerouslySetInnerHTML={{ __html: alertDetail.productDesc }} /></li>
																						<li className="list-group-item text-secondary"><strong>Reason:</strong> <span dangerouslySetInnerHTML={{ __html: alertDetail.reason }} /></li>
																					</ul>
																				</div>
																			) : (
																				<p>No alert detail available.</p>
																			)

																		)}

																		<div className="col-md-6">
																			{attachments && attachments.length > 0 ? (
																				<div>

																					<ul className="list-group">
																						<li className="list-group-item active">Attachments</li>
																						{attachments.map((file, idx) => (

																							<li className="list-group-item text-secondary d-flex align-items-center" key={idx}>
																								<span className="text-primary">{file.clientId}&nbsp;-&nbsp;
																									<a href="#" onClick={e => { e.preventDefault(); handleAttachmentDownload(file); }}>
																										{file.fileName}
																									</a></span>
																							</li>
																						))}
																					</ul>
																				</div>
																			) : (
																				<p>No attachments available.</p>
																			)}
																		</div>
																	</div>

																	{cardContent === 'matchCriteria' && <div className="row mt-3">
																		<div className="col-md-6">
																			<div class="alert alert-primary" role="alert">
																				<strong>Product Criteria:</strong> {productCriteria}
																			</div>
																			<div class="alert alert-warning" role="alert">
																				<strong>Manufacturer Criteria:</strong> {mfrCriteria}
																			</div>
																		</div>
																		<div className="col-md-6">
																			<div class="alert alert-danger" role="alert">
																				<strong>Catalog Criteria:</strong> {ctlgCriteria}
																			</div>
																		</div>
																	</div>}
																</div>
															)}
														</div>



													)}

												</div>
											</div>
										</>
									)}
								</div>
							</div>
							<br />
							<div className="card text-secondary">
								<div className="card-header">Draft Review -  {clientName} ({selectedClient}) - {mrNumber}</div>
								<div className="card-body">
									<div className="mb-3">
										<ul className="nav nav-tabs">
											{[
												{ tabName: `Prd Mnfr Ctg (${lvl1aCount.current || 0})`, level: '1a' },
												{ tabName: `Mnfr Ctlg (${lvl2aCount.current || 0})`, level: '2a' },
												{ tabName: `Prd Ctlg (${lvl2bCount.current || 0})`, level: '2b' },
												{ tabName: `Mnfr Product (${lvl2cCount.current || 0})`, level: '2c' },
												{ tabName: `Catalog (${lvl3aCount.current || 0})`, level: '3a' },
												{ tabName: `Keyword (${kwCount.current || 0})`, level: 'keyword' },
											].map(({ tabName, level: tabLevel }) => (
												<li className="nav-item" key={tabLevel}>

													<button
														className={`nav-link ${activeTab === tabName ? (dateFilter === 'ON' ? 'active text-danger' : 'active') : (dateFilter === 'ON' ? 'text-danger' : 'text-secondary')}`}
														onClick={() => {
															setActiveTab(tabName);
															handleTabClick(tabLevel);  // Call only handleTabClick which will handle all the logic
														}}
													>
														{tabName}
													</button>

												</li>
											))}
										</ul>
									</div>

									<div className="d-flex align-items-center flex-wrap gap-2 mb-3">
										<div className="btn-group">
											<div ref={excludeFieldDropdownRef}>
												<button
													className="btn btn-secondary btn-sm dropdown-toggle"
													onClick={handleExcludeFieldClick}
												>
													Exclude Field
												</button>
												{excludeFieldDropdownVisible && (
													<div className="dropdown-menu show position-absolute mt-1">
														{excludeFieldOptions.length === 0 ? (
															<div className="dropdown-item text-secondary">Loading...</div>
														) : (

															[
																{ val1: 'No Exclude Field', isNoExclude: true },
																...excludeFieldOptions
															].map((option, idx) => (
																<button
																	key={idx}
																	className="dropdown-item"
																	onClick={() => handleOptionSelect(option.isNoExclude ? null : (option.val1 || option))}
																>
																	{option.val1 || JSON.stringify(option)}
																</button>
															))

														)}
													</div>
												)}
											</div>
										</div>
										{/**end of exclude button */}
										<div className="btn-group">
											<button
												type="button"
												className="btn btn-info btn-sm dropdown-toggle text-light"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												Add To Bucket
											</button>
											<ul className="dropdown-menu">
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleAddToBucket('selected')}
													>
														Add Selected Items To Bucket
													</button>
												</li>
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleAddToBucket('all')}
													>
														Add All Items To Bucket
													</button>
												</li>
											</ul>
										</div>


										<div className="btn-group">
											<button
												type="button"
												className="btn btn-danger btn-sm dropdown-toggle"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												Delete From Bucket
											</button>
											<ul className="dropdown-menu">
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleDeleteFromBucket('selected')}
													>
														Remove Selected Items From Bucket
													</button>
												</li>
												<li>
													<button
														className="dropdown-item"
														onClick={() => handleDeleteFromBucket('all')}
													>
														Remove All Items From Bucket
													</button>
												</li>
											</ul>
										</div>


										<button
											className="btn btn-success btn-sm"
											onClick={handleMakeDraftReviewComplete}
										>
											Make Draft Review Complete
										</button>
										{isKeywordSearchVisible && (
																					<div className="btn-group">
																						<button
																							type="button"
																							className="btn btn-warning btn-sm dropdown-toggle"
																							data-bs-toggle="dropdown"
																							aria-expanded="false"
																						>
																							Keyword Search
																						</button>
																						<ul className="dropdown-menu">
																							{keywordOptions.showDeleteOptions && (
																								<>
																									<li>
																										<button
																											className="dropdown-item"
																											onClick={() => handleKeywordAction('deleteAllKeywordSearch')}
																										>
																											Delete All Keyword Search
																										</button>
																									</li>
																									<li>
																										<button
																											className="dropdown-item"
																											onClick={() => handleKeywordAction('deleteSelectedKeywordSearch')}
																										>
																											Delete Selected Item from Keyword Search
																										</button>
																									</li>
																								</>
																							)}
																							{keywordOptions.showSaveOptions && (
																								<>
																									<li>
																										<button
																											className="dropdown-item"
																											onClick={() => handleKeywordAction('saveAllKeywordSearch')}
																										>
																											Save All Keyword Search
																										</button>
																									</li>
																									<li>
																										<button
																											className="dropdown-item"
																											onClick={() => handleKeywordAction('saveSelectedKeywordSearch')}
																										>
																											Save Selected Item To Keyword Search
																										</button>
																									</li>
																								</>
																							)}
																							<li>
																								<button
																									className="dropdown-item"
																									onClick={() => handleKeywordAction('startNewKeywordSearch')}
																								>
																									Start A New Keyword Search
																								</button>
																							</li>
																						</ul>
																					</div>
																				)}
										<div className="ms-auto d-flex align-items-center gap-2">
											<select
												id="pageSizeDropdown"
												className="form-select"
												value={pageSize}
												onChange={(e) => {
													const newPageSize = Number(e.target.value);
													setPageSize(newPageSize); // Update the page size state
													setCurrentPage(1); // Reset to the first page

													// Use the newPageSize directly in the fetchRowData call
													fetchRowData(level, dateFilter, searchQuery, levelUrl, 1, excludeField, newPageSize);
												}}
												style={{ maxWidth: '90px' }}
											>
												<option value={20}>20</option>
												<option value={50}>50</option>
												<option value={100}>100</option>
											</select>
											&nbsp;

											<SearchComponent
												ref={searchComponentRef}
												viewMode={viewMode}
												toggleViewMode={() => setViewMode(viewMode === 'table' ? 'card' : 'table')}
												style={{ width: '300px' }}
												onSearch={(searchText) => {
													setSearchQuery(searchText);
													setCurrentPage(1);
													if(!excludeField){
														fetchRowData(level, dateFilter, searchText, levelUrl, 1, excludeField); // Explicitly pass page 1
													}else{
														PopupService.getInstance().showMessage('Search Not Available in Exclude Mode', false, 5000);

														// Clear the search input
														if (searchComponentRef.current) {
														  searchComponentRef.current.clearSearch();
														}
													}
												}}
											/>

										</div>
									</div>
									{loading ? (
										<div>Loading...</div>
									) : (
										viewMode === 'table' ? (
											<div className="table-responsive">
												<div>
													<table className="table table-responsive-sm text-secondary table-bordered table-striped table-sm">
														<thead>
															<tr>
																<th>
																	<input
																		type="checkbox"
																		id="selectAllCheckbox"
																		onChange={(e) => selectAllCheckboxChange(e.target.checked)}
																		checked={checkedItems.length === rowdata.length && rowdata.length > 0}
																	/>
																</th>
																<th>#</th>
																{columns.map((col, idx) => (
																	<th key={idx}>{col.val1}</th>
																))}
															</tr>
														</thead>
														<tbody>
															{paginatedRows.length === 0 ? (
																<tr className='table-danger'>
																	<td colSpan={columns.length + 2} className="text-center table-danger">No data found</td>
																</tr>
															) : (
																paginatedRows.map((row, rowIdx) => (
																	<tr
																		key={rowIdx}
																		className={row.st_selected === 'YES' ? 'table-warning' : ''}
																		onClick={event => handleRowClick(row.mongo_id, event)}
																	>
																		<td>
																			<input
																				type="checkbox"
																				id={row.mongo_id}
																				value={row.mongo_id}
																				onChange={(e) =>
																					handleCheckboxChange(row.mongo_id, e.target.checked)
																				}
																				checked={checkedItems.includes(row.mongo_id)}
																			/>
																		</td>
																		<td>{(currentPage - 1) * pageSize + rowIdx + 1}</td>
																		{columns.map((col, colIdx) => (
																			<td
																				key={colIdx}
																				dangerouslySetInnerHTML={{ __html: row[col.val1] || row[col.key] || '-' }}
																				className="text-nowrap"
																			/>
																		))}
																	</tr>
																))
															)}
														</tbody>
													</table>
												</div>
											</div>
										) : (

											<div className="row">
												{paginatedRows.map((row, rowIndex) => (
													<div className="col-md-4 mb-3" key={rowIndex}>
														<div className="card">
															<div className="card-body">
																<ul className="list-group">
																	<li
																		className={`list-group-item  list-group-item-secondary`}
																	>
																		#&nbsp;{(currentPage - 1) * pageSize + rowIndex + 1}&nbsp;-&nbsp;
																		<input
																			type="checkbox"
																			id={row.mongo_id}
																			value={row.mongo_id}
																			onChange={(e) =>
																				handleCheckboxChange(row.mongo_id, e.target.checked)
																			}
																			checked={checkedItems.includes(row.mongo_id)}
																		/> Select
																	</li>
																	{columns.map((col, colIndex) => (
																		<li
																			key={colIndex}
																			className={`list-group-item  ${row.st_selected === 'YES' ? 'light-yellow' : ''}`}
																		>
																			<strong>{col.displayName || col.val1}:</strong>{' '}
																			<span dangerouslySetInnerHTML={{ __html: row[col.val1] || row[col.key] || '-' }} />
																		</li>
																	))}
																</ul>
															</div>
														</div>
													</div>
												))}
											</div>

										)
									)}

									{paginatedRows.length > 0 && (
										<div className="d-flex justify-content-between align-items-center mt-3">

											<nav>
												<ul className="pagination mb-0">
													<li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
														<button
															className="page-link text-secondary"
															onClick={() => fetchRowData(level, dateFilter, searchQuery, levelUrl, 1, excludeField)}
															disabled={currentPage === 1}
														>
															First
														</button>
													</li>
													<li className={`page-item${currentPage === 1 ? ' disabled' : ''}`}>
														<button
															className="page-link text-secondary"
															onClick={() => fetchRowData(level, dateFilter, searchQuery, levelUrl, currentPage - 1, excludeField)}
															disabled={currentPage === 1}
														>
															Previous
														</button>
													</li>
													{pageNumbers.map((page) => (
														<li key={page} className={`page-item${currentPage === page ? ' active' : ''}`}>
															<button
																className={`page-link ${currentPage === page ? 'text-light' : 'text-secondary'}`}
																onClick={() => fetchRowData(level, dateFilter, searchQuery, levelUrl, page, excludeField)}
															>
																{page}
															</button>
														</li>
													))}
													<li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>
														<button
															className="page-link text-secondary"
															onClick={() => fetchRowData(level, dateFilter, searchQuery, levelUrl, currentPage + 1, excludeField)}
															disabled={currentPage === totalPages}
														>
															Next
														</button>
													</li>
													<li className={`page-item${currentPage === totalPages ? ' disabled' : ''}`}>

														<button
															className="page-link text-secondary rounded-end"
															onClick={() => fetchRowData(level, dateFilter, searchQuery, levelUrl, totalPages, excludeField)}
															disabled={currentPage === totalPages}
														>
															Last
														</button>

													</li>



													<li>
														<div className="d-flex align-items-center ms-3">
															<span className="me-2 text-secondary">Go to page:</span>
															<input
																type="number"
																className="form-control"
																style={{ width: '70px' }}
																min={1}
																max={totalPages}
																defaultValue={currentPage}
																id="pageInput"
																onKeyDown={e => {
																	if (e.key === 'Enter') {
																		const value = parseInt(e.target.value, 10);
																		if (!isNaN(value) && value >= 1 && value <= totalPages) {
																			fetchRowData(level, dateFilter, searchQuery, levelUrl, value, excludeField);
																		} else {
																			PopupService.getInstance().showMessage('Entered page number not valid', false, 3000);
																			e.target.value = currentPage;
																		}
																	}
																}}
															/>
															&nbsp;
															<button
																className="btn btn-secondary"
																onClick={() => {
																	const input = document.getElementById('pageInput');
																	const value = parseInt(input.value, 10);
																	if (!isNaN(value) && value >= 1 && value <= totalPages) {
																		fetchRowData(level, dateFilter, searchQuery, levelUrl, value, excludeField);
																	} else {
																		PopupService.getInstance().showMessage('Entered page number not valid', false, 3000);
																		input.value = currentPage;
																	}
																}}
															>
																GO
															</button>
														</div>

													</li>
												</ul>
											</nav>

											<span className="text-secondary">
												Page {currentPage} of {totalPages} | Total Records: {totalRecords}
											</span>
										</div>
									)}

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default DraftReview;